import React from 'react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import HeroSection from '@/app/components/HeroSection';
import HomeEventsSections from '@/app/components/HomeEventsSections';
import AboutSection from '@/app/components/AboutSection';
import NewsletterSection from '@/app/components/NewsletterSection';
import PageTransition from '@/components/PageTransition';

export default function HomePage() {
  return (
    <main className="min-h-screen bg-background">
      <Header />
      <PageTransition>
        <HeroSection />
        <HomeEventsSections />
        <AboutSection />
        <NewsletterSection />
        <Footer />
      </PageTransition>
    </main>
  );
}
